import { useSelector } from 'react-redux';
import Alooma from 'services/alooma';
import EmptyState from 'components/molecules/EmptyState/EmptyState';
import LoadMoreNewSales from 'components/organisms/LoadMoreNewSales/LoadMoreNewSales';
import * as newSalesSelectors from 'store/newSales/selectors';
import useShowCompleteLastLineOfItems from 'hooks/useShowCompleteLastLineOfItems';
import { useCardSalesBreakpoints } from 'hooks/grid/useCardSalesBreakpoint';
import CardSales from 'components/molecules/CardSales/CardSales';
import ItemsGrid from 'components/organisms/ItemsGrid/ItemsGrid';

const BlockCardSales = () => {
  const newSales = useSelector(newSalesSelectors.getNewSales);
  const newSalesLeft = useSelector(newSalesSelectors.getNewSalesLeft);
  const breakpoints = useCardSalesBreakpoints();

  const { items, slidesPerView } = useShowCompleteLastLineOfItems(newSales, breakpoints, newSalesLeft);

  return items.length ? (
    <LoadMoreNewSales>
      <ItemsGrid columns={slidesPerView} rowGap={40}>
        {newSales.map(newSale => (
          <div key={newSale.ad_package_id}>
            <Alooma.PackageIdContext.Provider value={newSale.ad_package_id}>
              <CardSales newSale={newSale} />
            </Alooma.PackageIdContext.Provider>
          </div>
        ))}
      </ItemsGrid>
    </LoadMoreNewSales>
  ) : (
    <EmptyState title="app:couldNotFindStores" />
  );
};

export default BlockCardSales;
